export const queryBuilder = {
    build: function (
        filters?: { [key: string]: any },
        sortField?: string,
        sortOrder: 'asc' | 'desc' = 'asc',
        page: number = 1,
        pageSize: number = 25
    ): string {
        const queryParts: string[] = [];

        if (filters && Object.keys(filters).length > 0) {
            const filterClauses: string[] = [];

            for (const key in filters) {
                const value = filters[key];

                if (Array.isArray(value)) {
                    const orClauses = value.map(v => `${key} eq ${formatValue(v)}`);
                    filterClauses.push(`(${orClauses.join(' or ')})`);
                } else if (value !== undefined && value !== null && value !== '') {
                    filterClauses.push(`${key} eq ${formatValue(value)}`);
                }
            }

            if (filterClauses.length > 0) {
                queryParts.push(`$filter=${encodeURIComponent(filterClauses.join(' and '))}`);
            }
        }

        if (sortField) {
            queryParts.push(`$orderby=${encodeURIComponent(sortField)} ${sortOrder}`);
        }

        if (pageSize > 0) {
            const skip = (page - 1) * pageSize;
            queryParts.push(`$skip=${skip}`);
            queryParts.push(`$top=${pageSize}`);
        }

        return queryParts.length ? `${queryParts.join('&')}` : '';
    },

    pagination: function(page: number, pageSize: number): string {
        const skip = (page - 1) * pageSize
        return `skip=${skip}&top=${pageSize}`
    }
}

function formatValue(val: any): string {
    if (typeof val === 'string') {
        return `'${val}'`
    }
    return val
}
